export function getNonEmptyStringOrDefault(str, defaultValue) {
    return str && str !== "" ? str : defaultValue;
}